import React, { useRef, useState } from "react";
import SignaturePad from "react-signature-canvas";
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const ServiceBooking = () => {
  const sigPadRef = useRef(null);
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    passport: "",
    address: "",
    insurance: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const clearSignature = () => sigPadRef.current?.clear();

  const handleSubmit = (e) => {
    e.preventDefault();

    let signatureData = "";

    try {
      if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
        signatureData = sigPadRef.current
          .getTrimmedCanvas()
          .toDataURL("image/png");
      }
    } catch (err) {
      console.error("Signature capture failed:", err);
      alert("Signature pad error. Try again.");
      return;
    }

    const submission = {
      ...form,
      signature: signatureData,
    };

    console.log("Form Data:", submission);
    alert("Booked Successfully!");
    navigate("/");
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f3f4f6",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 6,
        px: 2,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 900,
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          borderRadius: 3,
          boxShadow: 4,
          overflow: "hidden",
        }}
      >
        {/* Left Info Section */}
        <Box
          sx={{
            flex: 1,
            bgcolor: "rgb(54, 57, 92)",
            color: "#fff",
            p: 4,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Need Help Booking?
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.9, mb: 3 }}>
            Our team will assist you in booking the right medical services.
          </Typography>
          <Button
            variant="outlined"
            color="inherit"
            href="tel:+1234567890"
            sx={{ width: "fit-content", borderColor: "#fff" }}
          >
            Call Us
          </Button>
        </Box>

        {/* Right Form Section */}
        <CardContent sx={{ flex: 1.5, p: { xs: 3, md: 4 } }}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            Book a Medical Service
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <form
            onSubmit={handleSubmit}
            style={{ display: "flex", gap: "14px", flexDirection: "column" }}
          >
            <TextField
              label="Full Name"
              name="name"
              value={form.name}
              onChange={handleChange}
              fullWidth
              size="small"
            />
            <TextField
              label="Email"
              name="email"
              value={form.email}
              onChange={handleChange}
              fullWidth
              size="small"
              type="email"
            />
            <TextField
              label="Phone Number"
              name="passport"
              value={form.passport}
              onChange={handleChange}
              fullWidth
              size="small"
            />
            <TextField
              label="Address"
              name="address"
              value={form.address}
              onChange={handleChange}
              fullWidth
              size="small"
            />
            <TextField
              label="Insurance Company"
              name="insurance"
              value={form.insurance}
              onChange={handleChange}
              fullWidth
              size="small"
            />

            {/* Signature */}
            <Box sx={{ mt: 3 }}>
              <Typography variant="body2" mb={1}>
                Signature
              </Typography>
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: 1,
                  width: "100%",
                  height: 120,
                }}
              >
                <SignaturePad
                  ref={sigPadRef}
                  canvasProps={{
                    style: {
                      width: "100%",
                      height: "100%",
                      borderRadius: "4px",
                    },
                  }}
                />
              </Box>
              <Button
                onClick={clearSignature}
                size="small"
                color="secondary"
                sx={{ mt: 1 }}
              >
                Clear
              </Button>
            </Box>

            {/* Submit */}
            <Box sx={{ mt: 3, textAlign: "right" }}>
              <Button
                type="submit"
                variant="contained"
                size="medium"
                // onClick={() => alert("Booking Successfully!!")}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "1rem",
                  borderRadius: "8px",
                  px: 3,
                  py: 1,
                  backgroundColor: "#007ad9",
                  "&:hover": {
                    backgroundColor: "#005fa3",
                  },
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                Book Now
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ServiceBooking;
